<template>
  <div class="mt-4 relative">
    <div class="d-flex justify-content-center spacing">
      <div class="title">Fizetendő adó és járulék</div>
    </div>

    <b-container>
      <b-row class="payable-margin">
        <b-col sm="12" lg="6" class="text-nowrap">
          <div
            @click="() => copyToClipboard('10032000-06056353')"
            v-b-tooltip title="Számlaszám másolása"
            class="cursor-pointer"
          >
            <i class="fas fa-copy text-muted mr-3"></i>
            <span class="text-style">SZJA</span>
          </div>
        </b-col>
        <b-col class="text-left text-lg-right" sm="12" lg="6">
          <span class="text-style text-lg-right">{{
            Number(selectedMode === 'yearly' ? selectedYearData.szja :selectedQuarterData.szja).toLocaleString("hu-HU") + " Ft"
          }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" lg="6" class="text-nowrap">
          <div
              @click="() => copyToClipboard('10032000-06055912')"
              v-b-tooltip title="Számlaszám másolása"
              class="cursor-pointer"
          >
            <i class="fas fa-copy text-muted mr-3"></i>
            <span class="text-style">Szocho</span>
          </div>
        </b-col>
        <b-col class="text-left text-lg-right" sm="12" lg="6">
          <span class="text-style text-lg-right">{{
            Number(selectedMode === 'yearly' ? selectedYearData.szocho :selectedQuarterData.szocho).toLocaleString("hu-HU") + " Ft"
          }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" lg="6" class="text-nowrap">
          <div
              @click="() => copyToClipboard('10032000-06055802')"
              v-b-tooltip title="Számlaszám másolása"
              class="cursor-pointer"
          >
            <i class="fas fa-copy text-muted mr-3"></i>
            <span translate="no" class="text-style">TB&#8203;</span>
          </div>
        </b-col>
        <b-col sm="12" lg="6" class="text-left text-lg-right">
          <span class="text-style text-right">{{
            Number(selectedMode === 'yearly' ? selectedYearData.tb :selectedQuarterData.tb).toLocaleString("hu-HU") + " Ft"
          }}</span>
        </b-col>
      </b-row>
      <div class="my-4"/>
      <div class="footnote mr-4">
        Befizetési határidő: {{ selectedQuarterData.paymentDueDate }}
      </div>
    </b-container>
  </div>
</template>

<script>

export default {
  name: "AtalanyCard",

  props: ["selectedMode", "selectedQuarterData", "selectedYearData"],

  methods: {
    copyToClipboard(value) {
      navigator.clipboard.writeText(value);
      this.$toast.success({
        title: '',
        message: 'Számlaszám vágólapra másolva',
      });
    },
  },
};
</script>

<style scoped>
.card-body {
  width: 100%;
  padding-left: 4rem !important;
  padding-right: 4rem !important;
}

.title {
  font-family: Jumper;
  color: #252734;
  font-size: 1.6rem;
  text-align: center;
  width: 100%;
  text-transform: uppercase;
}

.fa-copy {
  font-size: 1.2rem;
  margin: 0 0 0.2rem 0.2rem;
  color: #d8d8d7;
  cursor: pointer;
}

.text-style {
  font-weight: 600;
  font-size: 18px;
  white-space: nowrap;
}

@media screen and (max-width: 1246px) {
  .text-style  {
    font-size: 30px;
  }
}

.footnote {
  text-align: right;
  color: #b2ec5d;
  font-weight: bold;
  font-size: 0.9rem;
  bottom: 0;
  right: 0;
}

.spacing {
  margin-bottom: 20px;
}
.payable-margin {
  margin-top: 65px;
}
@media screen and (max-width: 1246px) {
  .payable-margin {
    margin-top: 0px;
  }
}

</style>